export const versions = {
  version: "1.0.183",
  revision: "fdefc4c88",
  branch: "HEAD",
  gitInfo: {
    dirty: true,
    raw: "v1.0.183-4974-gfdefc4c88-dirty",
    hash: "gfdefc4c88",
    distance: 4974,
    tag: "v1.0.183",
    semver: {
      options: { loose: false, includePrerelease: false },
      loose: false,
      raw: "v1.0.183",
      major: 1,
      minor: 0,
      patch: 183,
      prerelease: [],
      build: [],
      version: "1.0.183"
    },
    suffix: "4974-gfdefc4c88-dirty",
    semverString: "1.0.183+4974.gfdefc4c88.dirty"
  }
};
